import { useState, useEffect, useCallback } from 'react';
import api from '../api';

const OTP_EMAIL = 'techflyerstore@gmail.com';

export default function VersionPage() {
  const [versions, setVersions]   = useState([]);
  const [form, setForm]           = useState({ name: '', url: '', description: '' });
  const [saving, setSaving]       = useState(false);
  const [formError, setFormError] = useState('');
  const [viewModal, setViewModal] = useState(null);

  // OTP state
  const [otpModal, setOtpModal]         = useState(false);
  const [otp, setOtp]                   = useState('');
  const [otpSending, setOtpSending]     = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpError, setOtpError]         = useState('');
  const [otpSent, setOtpSent]           = useState(false);

  const fetchVersions = useCallback(async () => {
    try {
      const { data } = await api.get('/admin/versions');
      setVersions(data.data);
    } catch {}
  }, []);

  useEffect(() => { fetchVersions(); }, [fetchVersions]);

  // Step 1: validate form fields, then send OTP
  const handleAdd = async (e) => {
    e.preventDefault();
    setFormError('');
    setOtpSending(true);
    try {
      await api.post('/admin/versions/send-otp', { name: form.name, url: form.url });
      setOtpModal(true);
      setOtp('');
      setOtpError('');
      setOtpSent(true);
    } catch (err) {
      setFormError(err.response?.data?.message || 'Failed to send OTP');
    } finally {
      setOtpSending(false);
    }
  };

  const sendOtp = async () => {
    setOtpSending(true);
    setOtpError('');
    try {
      await api.post('/admin/versions/send-otp', { name: form.name, url: form.url });
      setOtpSent(true);
    } catch (err) {
      setOtpError(err.response?.data?.message || 'Failed to send OTP');
    } finally {
      setOtpSending(false);
    }
  };

  // Step 2: verify OTP → backend adds version on success
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setOtpError('');
    setOtpVerifying(true);
    try {
      await api.post('/admin/versions/verify-otp', { otp, ...form });
      setOtpModal(false);
      setForm({ name: '', url: '', description: '' });
      setOtp('');
      fetchVersions();
    } catch (err) {
      setOtpError(err.response?.data?.message || 'Invalid or expired OTP');
    } finally {
      setOtpVerifying(false);
    }
  };

  const openView = async (id) => {
    try {
      const { data } = await api.get(`/admin/versions/${id}`);
      setViewModal(data.data);
    } catch {}
  };

  const closeOtpModal = () => { setOtpModal(false); setOtp(''); setOtpError(''); };

  return (
    <div>
      {/* Add Version Form */}
      <div className="table-card" style={{ marginBottom: 24 }}>
        <div className="card-header">
          <span className="card-title">📦 Add App Version</span>
        </div>
        <form onSubmit={handleAdd} style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end', paddingTop: 8 }}>
          <div style={vs.field}>
            <label style={vs.label}>Version Name</label>
            <input style={vs.input} placeholder="e.g. 1.0.0" value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })} required />
          </div>
          <div style={{ ...vs.field, minWidth: 240 }}>
            <label style={vs.label}>Download URL</label>
            <input style={vs.input} type="url" placeholder="https://..." value={form.url}
              onChange={(e) => setForm({ ...form, url: e.target.value })} required />
          </div>
          <div style={{ ...vs.field, minWidth: 200 }}>
            <label style={vs.label}>Description</label>
            <input style={vs.input} placeholder="Release notes (optional)" value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })} />
          </div>
          <div>
            <button className="logout-btn" style={{ background: '#2563eb', padding: '9px 22px', fontSize: 14 }}
              type="submit" disabled={otpSending}>
              {otpSending ? 'Sending OTP...' : '+ Add Version'}
            </button>
          </div>
          {formError && <p style={{ ...vs.error, width: '100%' }}>{formError}</p>}
        </form>
      </div>

      {/* Versions Table */}
      <div className="table-card">
        <div className="card-header">
          <span className="card-title">App Versions</span>
          <span style={{ fontSize: 13, color: '#718096', marginLeft: 8 }}>{versions.length} total</span>
        </div>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Version</th>
                <th>Download URL</th>
                <th>Created Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {versions.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: '#a0aec0', padding: 32 }}>No versions added yet</td></tr>
              )}
              {versions.map((v, i) => (
                <tr key={v.id}>
                  <td>{i + 1}</td>
                  <td><span style={vs.versionBadge}>{v.name}</span></td>
                  <td>
                    <a href={v.url} target="_blank" rel="noreferrer" style={{ color: '#2563eb', fontSize: 13 }}>
                      {v.url.length > 50 ? v.url.slice(0, 50) + '…' : v.url}
                    </a>
                  </td>
                  <td style={{ fontSize: 13, color: '#718096' }}>{new Date(v.created_at).toLocaleDateString()}</td>
                  <td>
                    <button style={vs.viewBtn} onClick={() => openView(v.id)}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* OTP Modal */}
      {otpModal && (
        <div style={vs.backdrop} onClick={closeOtpModal}>
          <div style={vs.modalBox} onClick={(e) => e.stopPropagation()}>
            <div style={vs.modalHeader}>
              <span style={vs.modalTitle}>OTP Verification</span>
              <button style={vs.closeBtn} onClick={closeOtpModal}>✕</button>
            </div>
            <div style={vs.modalBody}>
              {otpSending ? (
                <p style={{ textAlign: 'center', color: '#718096', fontSize: 14 }}>Sending OTP...</p>
              ) : (
                <>
                  <p style={{ fontSize: 14, color: '#4a5568', marginBottom: 16 }}>
                    An OTP has been sent to <strong>{OTP_EMAIL}</strong>. Enter it below to proceed.
                  </p>
                  <form onSubmit={handleVerifyOtp}>
                    <label style={vs.label}>Enter OTP</label>
                    <input
                      style={{ ...vs.input, width: '100%', marginTop: 6, marginBottom: 4, letterSpacing: 6, fontSize: 20, textAlign: 'center' }}
                      type="text" inputMode="numeric" maxLength={6} placeholder="------"
                      value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                      autoFocus required
                    />
                    {otpError && <p style={{ ...vs.error, marginBottom: 10 }}>{otpError}</p>}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                      <button type="button" style={vs.resendBtn} disabled={otpSending}
                        onClick={sendOtp}>
                        {otpSending ? 'Resending...' : 'Resend OTP'}
                      </button>
                      <div style={{ display: 'flex', gap: 10 }}>
                        <button type="button" style={vs.cancelBtn} onClick={closeOtpModal}>Cancel</button>
                        <button type="submit" style={vs.saveBtn} disabled={otpVerifying || otp.length < 6}>
                          {otpVerifying ? 'Verifying...' : 'Verify'}
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {viewModal && (
        <div style={vs.backdrop} onClick={() => setViewModal(null)}>
          <div style={vs.modalBox} onClick={(e) => e.stopPropagation()}>
            <div style={vs.modalHeader}>
              <span style={vs.modalTitle}>Version Details</span>
              <button style={vs.closeBtn} onClick={() => setViewModal(null)}>✕</button>
            </div>
            <div style={vs.modalBody}>
              <Row label="Version" value={<span style={vs.versionBadge}>{viewModal.name}</span>} />
              <Row label="Download URL" value={
                <a href={viewModal.url} target="_blank" rel="noreferrer" style={{ color: '#2563eb', wordBreak: 'break-all' }}>{viewModal.url}</a>
              } />
              <Row label="Description" value={viewModal.description || '—'} />
              <Row label="Created" value={new Date(viewModal.created_at).toLocaleString()} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 12, color: '#718096', marginBottom: 3 }}>{label}</div>
      <div style={{ fontSize: 14, color: '#2d3748' }}>{value}</div>
    </div>
  );
}

const vs = {
  field:         { display: 'flex', flexDirection: 'column', minWidth: 140 },
  label:         { fontSize: 13, color: '#4a5568', marginBottom: 5, fontWeight: 500 },
  input:         { padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 14, outline: 'none' },
  error:         { color: '#dc2626', fontSize: 13, marginTop: 4 },
  versionBadge:  { background: '#dbeafe', color: '#1d4ed8', padding: '3px 10px', borderRadius: 12, fontSize: 13, fontWeight: 600 },
  viewBtn:       { padding: '5px 14px', background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 5, cursor: 'pointer', fontSize: 13 },
  resendBtn:     { background: 'none', border: 'none', color: '#2563eb', fontSize: 13, cursor: 'pointer', padding: 0, textDecoration: 'underline' },
  backdrop:      { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  modalBox:      { background: '#fff', borderRadius: 10, width: '100%', maxWidth: 420, boxShadow: '0 8px 32px rgba(0,0,0,0.18)' },
  modalHeader:   { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #e2e8f0' },
  modalTitle:    { fontSize: 16, fontWeight: 600, color: '#2d3748' },
  closeBtn:      { background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#718096', lineHeight: 1 },
  modalBody:     { padding: '20px' },
  cancelBtn:     { padding: '8px 20px', background: '#e2e8f0', color: '#4a5568', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 },
  saveBtn:       { padding: '8px 24px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 500 },
};
